export const shiftIDToTrackingIDMapping = {
  Afternoon: 'afternoon',
  DayTime: 'day',
  NightTime: 'night',
  Overnight: 'overnight',
  Weekday: 'weekday',
  Weekend: 'weekend',
}
